<template>
  <i class="fa fa-fw fa-telegram"></i>
</template>

<script>
export default {
  name: 'Telegram',
};
</script>

<style scoped>
.fa-telegram {
  color: #1da1f2;
}
</style>





// WEBPACK FOOTER //
// TelegramIcon.vue?23e19159